namespace Portico.Models.Enterprise {
    import pmg = Portico.Models.Gateway;
	import psge = apigateway.enums;
	import psgm = apigateway.models;

    export interface ISite {
        id: number | string;
        description: string;
        nickName: string;
        businessEndTime: Date;
		businessStartTime: Date;
		roleType: psge.RoleType;

        addresses: Address[];
		contacts: Contact[];
        emailAddresses: EmailAddress[];
        externalIds: ExternalId[];
		phoneNumbers: PhoneNumber[];
		globalIds: GlobalId[];

		addAddress(index?: number): Address;
		addContact(index?: number): Contact;
		addEmailAddress(index?: number): EmailAddress;
		addExternalId(index?: number): ExternalId;
		addGlobalId(index?: number): GlobalId;
		addPhoneNumber(index?: number): PhoneNumber;
		isValidSearch(): boolean;
		mapToEnterpriseCoordinatorSiteUpsearchModel(): psgm.EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel;
		mapToEnterpriseCoordinatorSiteUpsearchModelWithFlags(canUpdate: boolean, canInsert: boolean, skipSearch: boolean): psgm.UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel;
		mapToSiteUpsearchModel(): psgm.SiteUpsearchModel;
	}

    export class Site implements ISite {
		id: number | string;
        description: string;
        nickName: string;
        businessEndTime: Date;
        businessStartTime: Date;
		roleType: psge.RoleType;

        addresses: Address[];
		contacts: Contact[];
        emailAddresses: EmailAddress[];
        externalIds: ExternalId[];
		phoneNumbers: PhoneNumber[];
		globalIds: GlobalId[];
		siteNote: string;

        constructor(obj?: ISite | any) {
            this.id = null;
            this.description = '';
            this.nickName = '';
            this.businessEndTime = null;
            this.businessStartTime = null;
			this.roleType = null;

            this.addresses = [];
			this.contacts = [];
            this.emailAddresses = [];
            this.externalIds = [];
			this.phoneNumbers = [];
			this.globalIds = [];
			this.siteNote = '';

            if (obj) {
				this.id = obj.id || obj.prescriberSiteId || obj.siteId || null;
				this.description = obj.description || obj.description || '';
				this.nickName = obj.nickName || '';
				this.roleType = obj.roleType || obj.siteRoleType || null;
				this.siteNote = obj.siteNote || '';

				if (obj.businessEndTime) {
					this.businessEndTime = new Date((obj.businessEndTime).toString());
                }

				if (obj.businessStartTime) {
					this.businessStartTime = new Date((obj.businessStartTime).toString());
                }

				if (obj.addresses) {
					for (const address of obj.addresses) {
						this.addresses.push(new Address(address));
					}
				}

				if (obj.contacts) {
                    for (const contact of obj.contacts) {
                        this.contacts.push(new Contact(contact));
                    }
				}

				if (obj.emailAddresses) {
					for (const emailAddress of obj.emailAddresses) {
						this.emailAddresses.push(new EmailAddress(emailAddress));
					}
				}

				if (obj.externalIds) {
					for (const externalId of obj.externalIds) {
						this.externalIds.push(new ExternalId(externalId));
					}
				}

				if (obj.phoneNumbers) {
					for (const phoneNumber of obj.phoneNumbers) {
						this.phoneNumbers.push(new PhoneNumber(phoneNumber));
					}
				}

				if (obj.globalIds) {
					for (const globalId of obj.globalIds) {
						this.globalIds.push(new GlobalId(globalId));
					}
				}
            }
        }

		addAddress(index: number = null): Address {
			const length = this.addresses.length;

			if (index && index < length) {
				return this.addresses[index];
			}

			const address = new Address();
			this.addresses.push(address);
			return address;
		}

		addContact(index: number = null): Contact {
			const length = this.contacts.length;

			if (index && index < length) {
				return this.contacts[index];
			}

			const contact = new Contact();
			this.contacts.push(contact);
			return contact;
		}

		addEmailAddress(index: number = null): EmailAddress {
			const length = this.emailAddresses.length;

			if (index && index < length) {
				return this.emailAddresses[index];
			}

			const emailAddress = new EmailAddress();
			this.emailAddresses.push(emailAddress);
			return emailAddress;
		}

		addExternalId(index: number = null): ExternalId {
			const length = this.externalIds.length;

			if (index && index < length) {
				return this.externalIds[index];
			}

			const externalId = new ExternalId();
			this.externalIds.push(externalId);
			return externalId;
		}

		addGlobalId(index: number = null): GlobalId {
			const length = this.globalIds.length;

			if (index && index < length) {
				return this.globalIds[index];
			}

			const globalId = new GlobalId();
			this.globalIds.push(globalId);
			return globalId;
		}

		addPhoneNumber(index: number = null): PhoneNumber {
			const length = this.phoneNumbers.length;

			if (index && index < length) {
				return this.phoneNumbers[index];
			}

			const phoneNumber = new PhoneNumber();
			this.phoneNumbers.push(phoneNumber);
			return phoneNumber;
		}

		isValidSearch(): boolean {
			let counter = 0;

			if (this.description) {
				counter++;
			}

			if (this.addresses) {
				if (this.addresses[0].city) {
					counter++;
				}

				if (this.addresses[0].state) {
					counter++;
				}

				if (this.addresses[0].zip) {
					counter++;
				}
			}

			return counter >= 1;
		}

		mapToEnterpriseCoordinatorSiteUpsearchModel(): psgm.EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel {
			return {
				siteId: Number(this.id),
				siteRoleType: this.roleType,
				description: this.description,
				nickName: this.nickName,
				businessStartTime: moment(this.businessStartTime),
				businessEndTime: moment(this.businessEndTime),
				addresses: this.addresses ? _.map(this.addresses, addr => {
					return Address.prototype.mapToEnterpriseCoordinatorAddress.call(addr);
				}) : [],
				contacts: this.contacts ? _.map(this.contacts, cnt => {
					return Contact.prototype.mapToEnterpriseCoordinatorContact.call(cnt);
				}) : [],
				emailAddresses: this.emailAddresses ? _.map(this.emailAddresses, email => {
					return EmailAddress.prototype.mapToEnterpriseCoordinatorEmailAddress.call(email);
				}) : [],
				externalIds: this.externalIds ? _.map(this.externalIds, ext => {
					return ExternalId.prototype.mapToEnterpriseCoordinatorExternalId.call(ext);
				}) : [],
				globalIds: this.globalIds ? _.map(this.globalIds, glblId => {
					return GlobalId.prototype.mapToEnterpriseCoordinatorGlobalId.call(glblId);
				}) : [],
				phoneNumbers: this.phoneNumbers ? _.map(this.phoneNumbers, ph => {
					return PhoneNumber.prototype.mapToEnterpriseCoordinatorPhoneUpsearchModel.call(ph);
				}) : []
			} as psgm.EnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel
		}

		mapToEnterpriseCoordinatorSiteUpsearchModelWithFlags(canUpdate: boolean, canInsert: boolean, skipSearch: boolean): psgm.UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchBaseModel {
			return {
				canUpdate: canUpdate,
				canInsert: canInsert,
				skipSearch: skipSearch,
				model: this.mapToEnterpriseCoordinatorSiteUpsearchModel()
			};
		}

		mapToSiteUpsearchModel(): psgm.SiteUpsearchModel {
			return <psgm.SiteUpsearchModel>{
				siteId: this.id,
				siteRoleType: this.roleType,
				siteNote: this.siteNote,
				description: this.description,
				nickName: this.nickName,
				businessStartTime: moment(this.businessStartTime),
				businessEndTime: moment(this.businessEndTime),
				accountRelationshipIsPrimary: false,
				addresses: this.addresses ? _.map(this.addresses, addr => {
					return Address.prototype.mapToEnterpriseCoordinatorAddress.call(addr);
				}) : [],
				contacts: this.contacts ? _.map(this.contacts, cntct => {
					return Contact.prototype.mapToEnterpriseCoordinatorContact.call(cntct);
				}) : [],
				emailAddresses: this.emailAddresses ? _.map(this.emailAddresses, email => {
					return EmailAddress.prototype.mapToEnterpriseCoordinatorEmailAddress.call(email);
				}) : [],
				externalIds: this.externalIds ? _.map(this.externalIds, extId => {
					return ExternalId.prototype.mapToEnterpriseCoordinatorExternalId.call(extId);
				}) : [],
				globalIds: this.globalIds ? _.map(this.globalIds, glblId => {
					return GlobalId.prototype.mapToEnterpriseCoordinatorGlobalId.call(glblId);
				}) : [],
				phoneNumbers: this.phoneNumbers ? _.map(this.phoneNumbers, ph => {
					return PhoneNumber.prototype.mapToEnterpriseCoordinatorPhoneUpsearchModel.call(ph);
				}) : [],
				pointOfContacts: [],				
			};
		}
    }
}

